import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { theme } from '@miro-site/design-tokens';
export var resetStyles = {
  transition: "color ".concat(theme.animation.transitionDuration, ", borderColor ").concat(theme.animation.transitionDuration),
  display: 'inline-block',
  border: 'none',
  textDecoration: 'none',
  cursor: 'pointer'
};

var dsFocusStyles = _objectSpread({}, theme.focus.outlines.withoutOffset);

var defaultLink = {
  borderBottom: "1px solid currentColor",
  transition: "border-color ".concat(theme.animation.transitionDuration),
  '&:hover': {
    borderColor: 'transparent'
  }
};
var linkWithArrow = {
  '&:hover': {
    '.link-text': {
      borderColor: 'transparent'
    }
  },
  '.link-text': {
    display: 'inline',
    borderBottom: "1px solid currentColor",
    transition: "border-color ".concat(theme.animation.transitionDuration)
  },
  '.link-arrow': {
    marginLeft: 5
  }
};
export var arrowLinkVariants = {
  "default": _objectSpread(_objectSpread({}, linkWithArrow), {}, {
    fontWeight: 500,
    '&:focus': _objectSpread({}, theme.focus.outlines.withOffset)
  }),
  regular: _objectSpread(_objectSpread({}, linkWithArrow), {}, {
    fontWeight: 400,
    '&:focus': _objectSpread({}, theme.focus.outlines.withOffset)
  }),
  richText: _objectSpread(_objectSpread({
    display: 'inline',
    fontWeight: 400,
    border: '1px solid transparent'
  }, linkWithArrow), {}, {
    '&:focus': _objectSpread({}, theme.focus.outlines["default"])
  }),
  dsDefault: _objectSpread(_objectSpread({}, linkWithArrow), {}, {
    '.link-text': _objectSpread(_objectSpread({}, linkWithArrow['.link-text']), {}, {
      borderBottom: 'none'
    }),
    color: "var(--colors-font-default-idle)",
    '&:hover': {
      color: "var(--colors-font-default-hover)"
    },
    '&:active': {
      color: "var(--colors-font-default-active)"
    },
    '&:focus': _objectSpread({}, dsFocusStyles)
  }),
  dsNeutral: _objectSpread(_objectSpread({}, linkWithArrow), {}, {
    '.link-text': {
      borderBottom: 'none'
    },
    color: "var(--wcds-legacy-link-color-idle)",
    '&:hover': {
      color: "var(--colors-font-default-hover)"
    },
    '&:active': {
      color: "var(--colors-font-default-active)"
    },
    '&:focus': _objectSpread({}, dsFocusStyles)
  })
};
export var variants = {
  "default": _objectSpread(_objectSpread({}, defaultLink), {}, {
    fontWeight: 500,
    '&:focus': _objectSpread({}, theme.focus.outlines.withOffset)
  }),
  regular: _objectSpread(_objectSpread({}, defaultLink), {}, {
    fontWeight: 400,
    '&:focus': _objectSpread({}, theme.focus.outlines.withOffset)
  }),
  richText: _objectSpread(_objectSpread({
    display: 'inline',
    fontWeight: 400,
    border: '1px solid transparent'
  }, defaultLink), {}, {
    '&:focus': _objectSpread({}, theme.focus.outlines["default"])
  }),
  dsDefault: {
    color: "var(--colors-font-default-idle)",
    '&:hover': {
      color: "var(--colors-font-default-hover)"
    },
    '&:active': {
      color: "var(--colors-font-default-active)"
    },
    '&:focus': _objectSpread({}, dsFocusStyles)
  },
  dsNeutral: {
    '.link-text': {
      borderBottom: 'none'
    },
    color: "var(--wcds-legacy-link-color-idle)",
    '&:hover': {
      color: "var(--colors-font-default-hover)"
    },
    '&:active': {
      color: "var(--colors-font-default-active)"
    },
    '&:focus': _objectSpread({}, dsFocusStyles)
  }
};
export var sizes = {
  dsBodyText1: {
    fontFamily: 'Formular',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: 'var(--font-sizes-225)',
    lineHeight: '135%',
    '.link-arrow::after': {
      marginLeft: 'var(--space-offset-50)',
      fontSize: 'var(--font-sizes-300)',
      position: 'relative'
    },
    '.focus-trap': {
      display: 'flex',
      alignItems: 'center'
    }
  },
  dsBodyText2: {
    fontFamily: 'Formular',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: 'var(--sizes-font-175)',
    lineHeight: '115%',
    '.link-arrow::after': {
      marginLeft: 'var(--space-offset-50)',
      fontSize: 'var(--font-sizes-300)',
      position: 'relative'
    },
    '.focus-trap': {
      display: 'flex',
      alignItems: 'center'
    }
  },
  small: {
    fontSize: 14,
    lineHeight: 20
  },
  "default": {
    fontSize: 18,
    lineHeight: 24
  },
  medium: {
    fontSize: 16,
    lineHeight: 24
  },
  large: {
    fontSize: 24,
    lineHeight: 32
  }
};
export var colors = {
  indigo: {
    color: theme.colors.primaryIndigo
  },
  "default": {
    color: theme.colors.primaryBlue,
    '&:hover': {
      color: theme.colors.primaryBlueHover
    }
  },
  white: {
    color: theme.colors.primaryWhite,
    '&:hover': {
      color: theme.colors.outspoken
    }
  },
  pink: {
    color: theme.colors.human
  },
  yellow: {
    color: theme.colors.outspoken
  }
};
export default {
  resetStyles: resetStyles,
  sizes: sizes,
  colors: colors,
  variants: variants,
  arrowLinkVariants: arrowLinkVariants
};